<app-modal [Modal]="{
    title: 'Advertencia',
    closeTitle: true,
    hiddenFooter: true
}">
    <ng-container body>
        <article>
            <ng-container>
                <p>El número de teléfono configurado no es válido. <br> Para configurar la doble autenticación por SMS, por
                    favor, actualice su número de teléfono en la sección de <strong>Mis datos</strong> para continuar.
                </p>
                <picture>
                </picture>
            </ng-container>
        </article>
        <div class="button-container">
            <button class="df-primario df-btn-xl" (click)="MisDatos()">
                Ir a mis datos
            </button>
        </div>
    </ng-container>
</app-modal>